export default __webpack_public_path__ + "static/media/hn.8c6234e6.svg";